import { render, staticRenderFns } from "./SexualFunctionInterpretation.vue?vue&type=template&id=38561672&scoped=true"
import script from "./SexualFunctionInterpretation.vue?vue&type=script&lang=js"
export * from "./SexualFunctionInterpretation.vue?vue&type=script&lang=js"
import style0 from "./SexualFunctionInterpretation.vue?vue&type=style&index=0&id=38561672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38561672",
  null
  
)

export default component.exports